module.exports = __webpack_public_path__ + "static/okunade-523b39aa38956a6b6415be52721ff1b1.png";